import { Component, Input, OnInit } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-product-rating',
  templateUrl: './product-rating.component.html',
  styleUrls: ['./product-rating.component.scss']
})
export class ProductRatingComponent implements OnInit {
  @Input() gridCell:GridCell;
  
  constructor() { }

  ngOnInit(): void {
  }

}
